import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { Subject } from 'rxjs';

export enum workModeEnum {
  OFFICE = 14,
  REMOTE = 2,
  REMOTEMORNING = 3,
  REMOTEAFTERNOON = 4
}

@Component({
  selector: 'app-modal-day-type',
  templateUrl: './modal-day-type.component.html',
  styleUrls: ['./modal-day-type.component.css']
})
export class ModalDayTypeComponent {
  private readonly _modalRef: NzModalRef = inject(NzModalRef);
  private readonly _fb: FormBuilder = inject(FormBuilder);

  limit: number;
  date: Date = new Date();
  dayType: number | null = null;
  workMode: workModeEnum;
  formDay: FormGroup;

  destroy$: Subject<void> = new Subject();

  constructor() {}

  ngOnInit() {
    this._initFormDay();
  }

  _initFormDay() {
    this.formDay = this._fb.group({
      regular: new FormControl(this.dayType == 13 ? this.dayType : null),
      limit: new FormControl(this.limit, Validators.required),
      day_type: new FormControl(this.dayType != 13 ? this.dayType : null)
    });

    if (this.dayType == 3 || this.dayType == 4) {
      this.formDay.addControl(
        'hybridOption',
        new FormControl(this.workMode, Validators.required)
      );
    }

    this.formDay.get('regular')?.valueChanges.subscribe(value => {
      if (value !== null && value !== undefined) {
        this.formDay.patchValue({
          day_type: null
        });
      }
      if (this.formDay.contains('hybridOption')) {
        this.formDay.removeControl('hybridOption');
      }
    });

    this.formDay.get('day_type')?.valueChanges.subscribe(value => {
      if (value !== null && value !== undefined) {
        this.formDay.patchValue({
          regular: null
        });
      }
      if (value === 'hybrid-day')
        this.formDay.addControl(
          'hybridOption',
          new FormControl(null, Validators.required)
        );
    });
  }

  isButtonEnabled(): boolean {
    const regular = this.formDay.get('regular')?.value;
    const dayType = this.formDay.get('day_type')?.value;
    const hybridOption = this.formDay.get('hybridOption')?.value;

    return (
      regular !== null ||
      (dayType === 'hybrid-day' && hybridOption) ||
      (dayType !== 'hybrid-day' && dayType !== null)
    );
  }

  /**
   * Funzione che serve per formattare ina data
   * @param date Data da formattare
   * @returns stringa in formato GG Mese Anno (es: 20 Settembre 2025)
   */
  formatDateItalian(date: Date): string {
    const day = date.getDate();
    const month = date.toLocaleString('it-IT', { month: 'long' });
    const year = date.getFullYear();
    const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);

    return `${day} ${capitalizedMonth} ${year}`;
  }

  closeModal() {
    this.formDay.reset();
    this._modalRef.close();
  }

  save() {
    this._modalRef.close(this.formDay.value);
    this._initFormDay();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
